import {toast} from 'react-toastify';

const traduzirErroItemFormando = (erro) => {
  const mensagem = (erro && erro.message) ? erro.message : '';
  if (mensagem.includes('ER_ROW_IS_REFERENCED') || mensagem.includes('item_formando_id') || mensagem.includes('foreign key constraint')) {
    return 'Não é possível reduzir a quantidade deste item porque ele já está vinculado a pedidos. Cancele ou ajuste os pedidos relacionados antes de diminuir a quantidade.';
  }
  return mensagem || 'Ocorreu um erro ao processar o item.';
};

const INITIAL_STATE = {
  todos: [],
  carregando: false,
  erro: null,
  ultimo: null
};

export default (state = INITIAL_STATE, action) => {
  switch(action.type){
    case 'REQUISITAR_ITEM_FORMANDO':
      return {...state, carregando: true};
    case 'ERRO_ITEM_FORMANDO':
      toast.error(traduzirErroItemFormando(action.erro), 5000);
      return {...state, carregando: false, erro: action.erro};
    case 'OBTER_TODOS_ITENS_FORMANDO':
      return {...state, carregando: false, todos: action.itens};
    case 'NOVO_ITEM_FORMANDO':
      return {...state, carregando: false, todos: state.todos.concat(action.itemFormando), ultimo: action.itemFormando};
    case 'ALTERAR_ITEM_FORMANDO':
      //toast.success("Item alterado com sucesso.", 5000);
      return {...state, carregando: false, todos: state.todos.filter((item) => {return item.id!==action.itemFormando.id}).concat(action.itemFormando)};
    case 'REMOVER_ITEM_FORMANDO':
      //toast.success("Item removido com sucesso.", 5000);
      return {...state, carregando: false, todos: state.todos.filter((item) => {return item.id!==action.id})};
    default:
      return state;
  }
};
